import { useContext, useState } from 'react';
import Brightness2Icon from '@material-ui/icons/Brightness2';
import WbSunnyRoundedIcon from '@material-ui/icons/WbSunnyRounded';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { ThemeContext } from '../../contexts/theme';
import useScrollSpy from '../../hooks/useScrollSpy';
import {
  projects,
  skills,
  contact,
  educations,
  experiences,
  publications,
  recommendations,
} from '../../portfolio';
import './Navbar.css';

const NAV_ITEMS = [
  {
    id: 'publications',
    label: 'Publications',
    show: () => publications.length > 0,
  },
  { id: 'experiences', label: 'Experience', show: () => experiences.length > 0 },
  { id: 'education', label: 'Education', show: () => educations.length > 0 },
  { id: 'skills', label: 'Skills', show: () => skills.length > 0 },
  { id: 'projects', label: 'Projects', show: () => projects.length > 0 },
  {
    id: 'recommendations',
    label: 'Recommendations',
    show: () => recommendations.length > 0,
  },
  { id: 'contact', label: 'Contact', show: () => !!contact.email },
];

const Navbar = () => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext);
  const [showNavList, setShowNavList] = useState(false);
  const activeSection = useScrollSpy(
    NAV_ITEMS.filter((item) => item.show()).map((item) => item.id)
  );

  const toggleNavList = () => setShowNavList(!showNavList);

  const handleNavClick = () => setShowNavList(false);

  return (
    <nav className='center nav'>
      <ul
        style={{ display: showNavList ? 'flex' : null }}
        className={`nav__list ${showNavList ? 'nav__list--open' : ''}`}
      >
        {NAV_ITEMS.filter((item) => item.show()).map(({ id, label }) => (
          <li key={id} className='nav__list-item'>
            <a
              href={`#${id}`}
              onClick={handleNavClick}
              className={`link link--nav ${
                activeSection === id ? 'link--nav-active' : ''
              }`}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>

      <button
        type='button'
        onClick={toggleTheme}
        className='btn btn--icon nav__theme'
        aria-label='toggle theme'
      >
        {themeName === 'dark' ? <WbSunnyRoundedIcon /> : <Brightness2Icon />}
      </button>

      <button
        type='button'
        onClick={toggleNavList}
        className='btn btn--icon nav__hamburger'
        aria-label='toggle navigation'
      >
        {showNavList ? <CloseIcon /> : <MenuIcon />}
      </button>
    </nav>
  );
};

export default Navbar;
